import D2C_TariffPlan from './Plan'

class D2C_TariffFree extends D2C_TariffPlan {
  isFree = true
  static objectType = 'tariffType'
  static active = true
  static tariffId = '58c0e161b2eac50001858817'
  static tariffTitle = 'Free'
  static order = 10
}

export default D2C_TariffFree
